export default class CaptureException {
  constructor({ payload, sentry }) {
    sentry.captureException(new Error( payload.name, payload.message, payload.stack));
  }
}